import axios, { AxiosInstance } from 'axios';
// ⚠️ DAİRESEL İMPORT GÜVENLİĞİ: ownAuthSession RAW axios kullanır (apiClient'ı
// import ETMEZ), bu yüzden buradan import etmek güvenlidir — döngü oluşmaz.
import * as ownAuthSession from '../services/auth/ownAuthSession';
// Alt admin işlem loglayıcı — RAW axios kullanır (apiClient'ı import etmez), güvenli.
import { recordApiWrite } from '../services/subAdminActivityLogger';
import { getManagerGuardMessage, handleManagerGuardResponse } from '../services/managerGuardNotice';
import {
  NETAPI_URL,
  ACCOUNTINGAPI_URL,
  WMSAPI_URL,
  SALESAPI_URL,
  REPORTSAPI_URL,
  ECOMMERCE_API_URL,
  SURVEY_API_URL,
  HRAPI_URL,
  TASKAPI_URL,
  EINVOICE_API_URL,
  AIAPI_URL,
} from './api';

const NODE_API_URL = process.env.REACT_APP_API_URL || 'https://gtsapi.mt-teknoloji.com';
const GETIR_API_URL = process.env.REACT_APP_GETIRAPI_URL || 'https://gtsintegrationapi.aquasoft.com.tr';
const MIGROS_API_URL = process.env.REACT_APP_MIGROSAPI_URL || 'https://gtsmigros.aquasoft.com.tr';
const TRENDYOL_API_URL = process.env.REACT_APP_TRENDYOLAPI_URL || 'https://gtstrendyol.aquasoft.com.tr';
const TRENDYOL_MP_API_URL = process.env.REACT_APP_TRENDYOLMPAPI_URL || 'https://tmp.aquasoft.com.tr';
const YEMEKSEPETI_API_URL = process.env.REACT_APP_YEMEKSEPETIAPI_URL || 'https://ysapi.aquasoft.com.tr';
const RESTAURANT_API_URL = process.env.REACT_APP_RESTAURANT_API || 'https://gtsrestaurant.aquasoft.com.tr';
const REMOTE_API_URL = process.env.REACT_APP_REMOTEAPI_URL || 'https://gtsremoteapi.aquasoft.com.tr';
const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || 'https://gtsauthapi.aquasoft.com.tr';
const N11_API_URL = process.env.REACT_APP_N11API_URL || 'http://localhost:5013';
const HEPSIBURADA_API_URL = process.env.REACT_APP_HEPSIBURADAAPI_URL || 'http://localhost:5020';
const HEPSIJET_API_URL = process.env.REACT_APP_HEPSIJETAPI_URL || 'http://localhost:5023';
const MNG_CARGO_API_URL = process.env.REACT_APP_MNGCARGOAPI_URL || 'http://localhost:5024';
const PAZARAMA_API_URL = process.env.REACT_APP_PAZARAMAAPI_URL || 'http://localhost:5021';
const PTTAVM_API_URL = process.env.REACT_APP_PTTAVMAPI_URL || 'http://localhost:5022';
const NOTIFICATION_API_URL = process.env.REACT_APP_NOTIFICATION_API_URL || 'https://gtsnotification.aquasoft.com.tr';


interface CreateApiClientOptions {
  /**
   * Token'i OLMAYAN cagrilarda X-Company-Id header'i eklensin mi? Varsayilan true.
   *
   * FAZ 5 NOTU: Oturumlu (token tasiyan) cagrilarda header artik bu bayraktan
   * BAGIMSIZ olarak hic gonderilmez — tenant JWT companyId claim'inden cozulur.
   * Bayrak yalnizca token'siz iki dali etkiler: grace period (claim'siz token) ve
   * musteri ekrani gibi anonim pencereler. `false` verilirse o dallar da kapanir.
   */
  sendCompanyHeader?: boolean;
}

function createApiClient(baseURL: string, options: CreateApiClientOptions = {}): AxiosInstance {
  const { sendCompanyHeader = true } = options;
  const instance = axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' },
    timeout: 60000,
  });

  instance.interceptors.request.use(async (config) => {
    // ─────────────────────────────────────────────────────────────────────────
    // MULTI-TENANT GÜVENLİK (Faz 4: own-auth)
    // X-Company-Id otorite sırası (kritik):
    //   1. Çağrıya explicit verilen X-Company-Id (asla override etmiyoruz)
    //   2. Own JWT (access token) claim (companyId) — oturum varsa MUTLAK otorite
    //   3. localStorage userDetails.companyId — SADECE oturum varsa fallback
    //   4. Müşteri ekranı penceresi (oturum yok) → __customerDisplayCompanyId localStorage
    //   5. Hiçbiri yok → header gönderme (anonim çağrı)
    //
    // NOT: Müşteri ekranında own oturum yoktur → ownAccessToken null olabilir.
    // ─────────────────────────────────────────────────────────────────────────
    let tokenCompanyId: string | undefined;
    let ownAccessToken: string | null = null;
    let hasAuthenticatedUser = false;

    try {
      // Own access token — gerekirse otomatik refresh (60 sn pencere) eder.
      ownAccessToken = await ownAuthSession.getAccessToken();
      if (ownAccessToken) {
        hasAuthenticatedUser = true;
        const claims = ownAuthSession.decodeJwt(ownAccessToken);
        const claimCompanyId = claims?.companyId;
        if (typeof claimCompanyId === 'string' && claimCompanyId.length > 0) {
          tokenCompanyId = claimCompanyId;
        }
      }
    } catch {
      // Token alınamadı — sessizce geç (oturum yok / müşteri ekranı)
    }

    // Authorization header
    if (ownAccessToken) {
      config.headers['Authorization'] = `Bearer ${ownAccessToken}`;
    } else {
      const cachedToken = localStorage.getItem('__customerDisplayAuthToken');
      if (cachedToken) {
        config.headers['Authorization'] = `Bearer ${cachedToken}`;
      }
    }

    // X-Company-Id header — FAZ 5
    //
    // Oturumlu çağrılarda header ARTIK GÖNDERİLMEZ. Şirket kimliği token'ın içindeki
    // `companyId` claim'inden okunur; token'ı sunucu imzaladığı için istemci onu
    // değiştiremez, oysa header'ı istemci serbestçe yazabiliyordu.
    //
    // Sunucu tarafında bu iki mekanizma claim'i her yolda görebiliyor:
    //   • Korumalı yollar → JwtAuthMiddleware claim'i doğrular ve tenant'a yazar.
    //   • Muaf yollar → aynı middleware claim'i "ipucu" olarak bırakır
    //     (TenantCompanyIdHint), TenantResolutionMiddleware onu kullanır.
    //
    // Header YALNIZCA token'ı olmayan çağrılarda gönderilir; onların başka bir
    // şirket kaynağı yok:
    if (sendCompanyHeader) {
      const hasExplicitCompanyHeader =
        !!config.headers['X-Company-Id'] || !!config.headers['x-company-id'];

      if (!hasExplicitCompanyHeader) {
        if (tokenCompanyId) {
          // Claim var → header'a GEREK YOK. Sunucu tenant'ı claim'den çözer
          // (TenantResolution logunda source=jwt_claim). Header eklemek ayrıca
          // gereksiz bir 403 COMPANY_ID_MISMATCH yüzeyi açardı.
        } else if (hasAuthenticatedUser) {
          // Oturum var ama token'da claim YOK → grace period. Bu, kullanıcının
          // SystemUsers.CompanyId alanının boş olduğu (veri hatası) veya claim
          // eklenmeden önce üretilmiş eski bir token taşıdığı durumdur. Sunucu bu
          // isteği ApiSecurityLogs'a TENANT_GRACE_PERIOD olarak kaydediyor
          // (bkz. sql/tenant-grace-period-monitor.sql). Ölçüm sıfırlanınca bu dal
          // ve sunucudaki grace dalı BİRLİKTE kaldırılacak — şimdi kaldırılırsa
          // claim'siz token taşıyan kullanıcılar tenant'ını çözemez.
          try {
            const stored = localStorage.getItem('userDetails');
            if (stored) {
              const details = JSON.parse(stored);
              if (details?.companyId) {
                config.headers['X-Company-Id'] = details.companyId;
              }
            }
          } catch {
            // localStorage parse hatası — sessizce geç
          }
        } else {
          // Oturum YOK — müşteri ekranı / anonim pencere. Token olmadığı için
          // şirket kimliğinin tek kaynağı bu cache; header KALICI olarak gerekli.
          // Ayrı bir key kullanılıyor (__customerDisplayCompanyId): logout ↔ login
          // yarışında userDetails.companyId gibi başka firmaya sızma riski taşımaz.
          const customerDisplayCompanyId = localStorage.getItem('__customerDisplayCompanyId');
          if (customerDisplayCompanyId) {
            config.headers['X-Company-Id'] = customerDisplayCompanyId;
          }
          // Hiçbiri yoksa header eklenmez (anonim çağrı, backend default connection kullanır)
        }
      }
    }

    // ── GEÇİCİ TANI: SQL kaynak izleme (Faz 7.5 doğrulama) ───────────────────
    // Tum SQL mikroservis trafigi bu interceptor'dan gecer. Konsolu "[SOURCE:" ile filtreleyin.
    if (process.env.NODE_ENV !== 'production') {
      // Faz 5'ten sonra oturumlu çağrılarda header yok; şirket kimliği claim'den gelir.
      // Log yine de hangi şirkete gidildiğini göstersin diye claim'e düşülür.
      const cid =
        config.headers['X-Company-Id'] ||
        config.headers['x-company-id'] ||
        (tokenCompanyId ? `${tokenCompanyId}/claim` : '-');
      const rawUrl = config.url || '';
      // url mutlak (http...) ise axios baseURL'i yok sayar; logda da cift gostermeyelim.
      const fullUrl = /^https?:\/\//i.test(rawUrl) ? rawUrl : `${config.baseURL || ''}${rawUrl}`;
      // eslint-disable-next-line no-console
      console.log('[SOURCE:SQL]', (config.method || 'get').toUpperCase(), fullUrl, `(cid:${cid})`);
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      // Alt admin denetim izi: yazma istekleri (subadmin oturumu) merkezi loglanır.
      recordApiWrite({
        method: response.config?.method,
        baseURL: response.config?.baseURL,
        url: response.config?.url,
        status: response.status,
      });
      return response;
    },
    async (error) => {
      const status = error.response?.status;
      // Alt admin denetim izi: başarısız yazma istekleri de loglanır (401 hariç —
      // logger içinde elenir; token yenilenip istek tekrarlanınca sonucu loglanır).
      recordApiWrite({
        method: error.config?.method,
        baseURL: error.config?.baseURL,
        url: error.config?.url,
        status,
      });
      const original = error.config as
        | (typeof error.config & { _retry?: boolean })
        | undefined;

      if (status === 401 && original && !original._retry) {
        // Auth endpoint'lerinde (login/refresh/logout) retry yapma — sonsuz döngü riski.
        const fullUrl = `${original.baseURL || ''}${original.url || ''}`;
        const isAuthEndpoint = fullUrl.includes('/api/auth/');

        if (!isAuthEndpoint) {
          original._retry = true;
          // Token'ı zorla yenile (de-dup edilir). Başarısızsa forceRefresh
          // içeride clearSession + 'refresh-failed' emit eder → AuthContext logout.
          const newToken = await ownAuthSession.forceRefresh();
          if (newToken) {
            original.headers = original.headers || {};
            original.headers['Authorization'] = `Bearer ${newToken}`;
            return instance(original);
          }
          console.warn('[API] 401 — token yenileme başarısız, oturum sonlandırıldı');
        }
      } else if (status === 401) {
        console.warn('[API] 401 Unauthorized — token suresi dolmus olabilir');
      }

      // Sunucu tarafinda RequireCompanyId() companyId claim'i bulamayinca
      // UnauthorizedAccessException firlatiyor, GlobalExceptionMiddleware ise tip
      // ayrimi yapmadan hepsini 500'e ceviriyor. 401 gelmedigi icin yukaridaki
      // yenileme dali calismaz; ekran olu token'la yenileme dongusune girer ve
      // kimse sayfayi elle yenilemedikce toparlanmaz (paket siparis ekraninda
      // 6-7 Eylul gecesi 10,5 saat surdu). Uretimde 500 govdesi genel bir mesaj
      // donduruyor, yani sebebi yanittan ayirt edemiyoruz; bu yuzden kosulu
      // ISTEMCI tarafinda kuruyoruz: token gercekten claim'siz mi?
      // Yalnizca yan etkisiz GET'lerde ve tek seferlik.
      if (
        status === 500 &&
        original &&
        !original._retry &&
        (original.method || 'get').toLowerCase() === 'get'
      ) {
        const fullUrl = `${original.baseURL || ''}${original.url || ''}`;
        if (!fullUrl.includes('/api/auth/')) {
          let claimMissing = false;
          try {
            const token = await ownAuthSession.getAccessToken();
            claimMissing = !token || !ownAuthSession.decodeJwt(token)?.companyId;
          } catch {
            claimMissing = true;
          }

          if (claimMissing) {
            original._retry = true;
            const newToken = await ownAuthSession.forceRefresh();
            if (newToken) {
              original.headers = original.headers || {};
              original.headers['Authorization'] = `Bearer ${newToken}`;
              return instance(original);
            }
            console.warn('[API] 500 + token\'da companyId claim yok — yenileme basarisiz');
          }
        }
      }

      if (status === 429) {
        console.warn('[API] 429 Too Many Requests — rate limit asildi');
      }

      const guardCode = handleManagerGuardResponse(status, error.response?.data);
      if (guardCode) {
        error.managerGuardCode = guardCode;
        error.message = getManagerGuardMessage(guardCode);
      }
      return Promise.reject(error);
    }
  );

  return instance;
}

export const mainApi = createApiClient(NETAPI_URL);
export const nodeApi = createApiClient(NODE_API_URL);
export const accountingApi = createApiClient(ACCOUNTINGAPI_URL);
// gts_einvoice_api: OwnJwt zorunlu — yalnizca Bearer token, X-Company-Id GONDERILMEZ
export const einvoiceApi = createApiClient(EINVOICE_API_URL, { sendCompanyHeader: false });
export const wmsApi = createApiClient(WMSAPI_URL);
export const salesApi = createApiClient(SALESAPI_URL);
// gts_ai_api: AI asistan (chat + ajan + AI rapor önerisi). Gemini çağrıları uzun sürebilir (45-90 sn).
export const aiApi = createApiClient(AIAPI_URL);
export const reportsApi = createApiClient(REPORTSAPI_URL);
export const ecommerceApi = createApiClient(ECOMMERCE_API_URL);
export const restaurantApi = createApiClient(RESTAURANT_API_URL);
export const getirApi = createApiClient(GETIR_API_URL);
export const migrosApi = createApiClient(MIGROS_API_URL);
export const trendyolApi = createApiClient(TRENDYOL_API_URL);
export const trendyolMpApi = createApiClient(TRENDYOL_MP_API_URL);
export const yemeksepetiApi = createApiClient(YEMEKSEPETI_API_URL);
export const remoteApi = createApiClient(REMOTE_API_URL);
export const authApi = createApiClient(AUTH_API_URL);
export const surveyApi = createApiClient(SURVEY_API_URL);
export const hrApi = createApiClient(HRAPI_URL);
export const taskApi = createApiClient(TASKAPI_URL);
export const n11Api = createApiClient(N11_API_URL);
export const hepsiburadaApi = createApiClient(HEPSIBURADA_API_URL);
export const hepsijetApi = createApiClient(HEPSIJET_API_URL);
export const mngCargoApi = createApiClient(MNG_CARGO_API_URL);
export const pazaramaApi = createApiClient(PAZARAMA_API_URL);
export const pttavmApi = createApiClient(PTTAVM_API_URL);
export const notifApi = createApiClient(NOTIFICATION_API_URL);
